import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import secureStorage from '../utils/secureStorage.js';

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      _hasHydrated: false,

      setHasHydrated: (state) => {
        set({ _hasHydrated: state });
      },

      setAuth: (user, token) => {
        secureStorage.setToken(token);
        set({ user, token, isAuthenticated: true });
        // Socket will be initialized when needed
      },

      logout: () => {
        secureStorage.removeToken();
        set({ user: null, token: null, isAuthenticated: false });
        // Socket disconnection handled by app cleanup
      },

      updateUser: (userData) => {
        set((state) => ({ user: { ...state.user, ...userData } }));
      },
    }),
    {
      name: 'auth-storage',
      skipHydration: false,
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
